import { Menu } from '@mantine/core';
import { EntityType } from '@repo/common/enums/entityType';
import { Icon } from '@repo/foundations';
import { useNavigate } from 'react-router';
import type { ISecodaEntity } from '../../../../api';
import { useDuplicateDocument } from '../../../../api/hooks/document/useDuplicateDocument';
import type { SecodaEntity } from '../../../../lib/models';
import { buildResourceUrl } from '../../../../utils/navigationUtils';

interface DuplicateActionProps {
	entity: SecodaEntity | ISecodaEntity;
}

export function DuplicateAction({ entity }: DuplicateActionProps) {
	const navigate = useNavigate();

	const canDuplicate = entity.entity_type === EntityType.document;

	const { mutateAsync: duplicate } = useDuplicateDocument({
		onSuccess: (data) => {
			navigate(buildResourceUrl(data));
		},
	});

	if (!canDuplicate) {
		return null;
	}

	const handleDuplicateClick = async () => {
		duplicate({ entity });
	};

	return (
		<Menu.Item icon={<Icon name="copy" />} onClick={handleDuplicateClick}>
			Duplicate
		</Menu.Item>
	);
}
